import WidgetModule from "@eisinc/Overrides/Widgets/Common/RecentOrders";

export * from "@eisinc/Overrides/Widgets/Common/RecentOrders";

export default WidgetModule;
